import React from "react";
import ProductDetail from "./ProductDetail";
import { products } from "../data/products";

const HighSpeedLaserPrinterPage = () => (
  <ProductDetail product={products.highSpeedLaserPrinter} />
);

export default HighSpeedLaserPrinterPage;
